import * as jQuery from 'jquery';
import * as _ from 'underscore';
import * as numeral from 'numeral';

import { AfterContentChecked, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DataTableComponent } from '../datatable/datatable.component';

@Component({
	selector: 'app-datatable-v5',
	styleUrls: ['./datatable-v5.component.css'],
	templateUrl: './datatable-v5.component.html'
})
export class DatatableV5Component
	extends DataTableComponent
	implements OnInit, WidgetCore, OnDestroy, AfterContentChecked
{
	@Input() sortdataby: any;
	@Input() defaultsort: string;
	@Input() iscustomendpoint: any;
	public dropdownList: any;

	constructor(protected analyticsService: AnalyticsService, analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (this.defaultsort === 'true') {
			this.defaultsort = JSON.parse(this.defaultsort);
		} else {
			this.defaultsort = null;
		}
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	ngAfterContentChecked(): void {
		jQuery('.datatable-body').css('overflow', 'hidden');
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r11') {
			jQuery('.ngx-datatable .datatable-footer .datatable-pager .pager li.active').addClass('primary-color-bg');
			jQuery('.ngx-datatable .datatable-footer .datatable-pager .pager li.active a').addClass('primary-color-bg');
		}
	}

	requestData() {
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key)
				.subscribe((res: any) => {
					this.showLoad = false;
					this.dataTableObj.data = [];
					if (res.success && res.data.length > 0) {
						this.hasData = true;
						this.dataTableObj.columns = this.generateColumnConfigurationForDataTable();
						this.processResponseData(res.data);
					} else {
						this.hasData = false;
						this.dataTableObj.data = [];
					}
				});
		} else {
			super.requestData();
		}
	}

	generateDateTableConfiguration(responseData: any): any {
		if (this.defaultsort) {
			return (this.dataTableObj.data = this.generateResponseDataFromConfig(responseData));
		}
		this.dataTableObj.data = _.sortBy(
			_.sortBy(
				// tslint:disable-next-line: only-arrow-functions
				_.sortBy(this.generateResponseDataFromConfig(responseData), function (clickrate: any): number {
					return Number(clickrate.click_rate);
				}),
				// tslint:disable-next-line: only-arrow-functions
				function (click: any): number {
					return Number(click.impressions);
				}
			),
			// tslint:disable-next-line: only-arrow-functions
			function (impression: any): number {
				return Number(impression.clicks);
			}
		).reverse();
		let indexPlatformPos;
		if (
			this.analyticsDataModel.config.version.toLowerCase() === 'r11' &&
			jQuery('.r11-datatable').attr('class').includes('r11-platform')
		) {
			this.dataTableObj.columns.forEach((item, index) => {
				if (item.name === 'Platform Logo') {
					indexPlatformPos = index;
				}
				if (indexPlatformPos >= 0) {
					this.dataTableObj.columns.splice(indexPlatformPos, 1);
					indexPlatformPos = -1;
				}
			});
		}
	}

	protected generateResponseDataFromConfig(responseData: any): any[] {
		const processedData = [];
		let lineItemsTotal = {};
		for (const responseObj of responseData) {
			processedData.push(this.getDerivedResponseObj(responseObj));
		}
		if (this.sectiontitle.toUpperCase().includes('LINE ITEM')) {
			this.lineItemTableData =
				this.selectedList =
				this.dropdownList =
					processedData.map((item) => ({ ...item, ...{ selected: true } }));
			this.dataTableObj.columns.forEach((item) => {
				let columnKey = item['columnKey'];
				let columnType = item['columnType'];
				let totalOfEachMetric = {};
				totalOfEachMetric[columnType == 'string' ? item['columnKey'] : 'formatted_' + item['columnKey']] =
					totalOfEachMetric[columnType == 'string' ? item['columnKey'] : item['columnKey']] =
						columnType.toUpperCase() == 'STRING'
							? 'Total'
							: this.sumOfLineItems(columnKey, this.lineItemTableData)[columnKey];
				lineItemsTotal = { ...lineItemsTotal, ...totalOfEachMetric };
			});
			lineItemsTotal['formatted_impressions'] = numeral(lineItemsTotal['impressions']).format('0,0');
			lineItemsTotal['formatted_clicks'] = numeral(lineItemsTotal['clicks']).format('0,0');
			lineItemsTotal['formatted_completions'] = numeral(lineItemsTotal['completions']).format('0,0');
			lineItemsTotal['formatted_clicks_rate'] = lineItemsTotal['formatted_clicks_percent'] =
				lineItemsTotal['impressions'] > 0
					? ((lineItemsTotal['clicks'] / lineItemsTotal['impressions']) * 100).toFixed(2) + '%'
					: '--';
			lineItemsTotal['formatted_completion_rate'] =
				lineItemsTotal['impressions'] > 0
					? ((lineItemsTotal['completions'] / lineItemsTotal['impressions']) * 100).toFixed(2) + '%'
					: '--';
			this.lineItemTableData.push(lineItemsTotal);
			this.dropdownList = this.dropdownList.filter((item) => item['lineItem'] != 'Total');
			this.selectedList = this.selectedList.filter((item) => item['lineItem'] != 'Total');
		}
		return processedData;
	}

	sumOfLineItems(key, data) {
		return data.reduce((a, b) => {
			let value = {};
			value[key] = a[key] + b[key];
			return value;
		});
	}
}
